import store from "../store";
import {getCommonVisualizerType} from "../config";
import {getPSADefaultQuantity} from "../bvcomponents/selectionWindow/selectionFeatureInfo/featureInfoDefaultQuantity";

/**
 *
 * @param feature {featureInterface} (object which has dbFeature property)
 * @param cartItems {[cartItemInterface]}
 * @param currentQuote {number}
 * @param allWizardsValues {array}
 * @param allDisplayLogicCartItems {array}
 * @param fabricatorState {object}
 * @return {object} // {quantity, isMatching}
 */
export default function featureIsMatchingDisplayLogic(feature,
                                                      cartItems = [],
                                                      currentQuote = 0,
                                                      allWizardsValues,
                                                      allDisplayLogicCartItems = [],
                                                      fabricatorState) {

  let visible = feature.dbFeature.displayLogic.action === "show";
  let quantity = 0;
  const displayRules = feature.dbFeature.displayRules;

  if (Array.isArray(displayRules) && displayRules.length) {

    const currentQuoteCartItems = cartItems.filter(cItem => cItem.currentQuote === currentQuote);
    let visibleUpdated = false; // we need to rewrite this, when we have time

    for (let i = 0; i < displayRules.length; i++) {
      const rule = displayRules[i];
      let entityVal = 0;
      // if (!rule) {
      //   console.log("feature", feature);
      // }
      if (rule && rule.entityId) {
        if (rule.entityId === -1) { // Material (should look for added Countertops value)
          let countertopCount = 0;
          currentQuoteCartItems.forEach((cartItem) => {
            if (cartItem.partId.includes("countertop")) {
              countertopCount += cartItem.quantity;
            }
          });
          entityVal = countertopCount
        } else {
          const matchingCartItem = currentQuoteCartItems.find((cartItem) => {
            return rule.entityId === cartItem.cartFeature.dbFeature.id
          });
          if (matchingCartItem) {
            entityVal = matchingCartItem.quantity
          }
        }
        let result = true;
        const
          entVal  = parseInt(entityVal),
          ruleVal = parseInt(rule.value);
        switch (rule.comparison) {
          case "<":
            result = (entVal === 0 && ruleVal === 0 ) ? true : entVal < ruleVal;
            break;
          case "<=":
            result = entVal <= ruleVal;
            break;
          case "=":
            result = entVal === ruleVal;
            break;
          case ">":
            result = entVal > ruleVal;
            break;
          case ">=":
            result = entVal >= ruleVal;
            break;
          case "wizard":
            result = allWizardsValues && allWizardsValues.some(wizObject => {
              return wizObject.quoteIndex === currentQuote && wizObject.wizardSelectedValues
                && Object.keys(wizObject.wizardSelectedValues).some(key => {
                  return wizObject.wizardSelectedValues[key].selectedFeature
                    && wizObject.wizardSelectedValues[key].selectedFeature.dbFeature.id === rule.entityId
                })
            });
            break;
        }
        if (!result) {
          if (!visibleUpdated) {
            visible = !visible;
            visibleUpdated = true;
          }
          quantity = quantity + entityVal;
        }
      }
    }
    //hardcode[renuit] if reface is selected in the wizard - and there are top and bottom cabinets
    if (fabricatorState && fabricatorState.isRenuit && (feature.partId === "psa" || feature.partId === "fee")) {
      const feeAndPsaObject = getRenuitFeeAndPsaVisible(feature, cartItems, allWizardsValues, currentQuote);
      if (feeAndPsaObject.shouldChange) {
        visible = feeAndPsaObject.visible;
        quantity = feeAndPsaObject.quantity;
      }
    }
  }
  if (visible
    && !feature.notAvailableInVisualizer // it means that this feature has layers! and should use filtering by room layout, size, etc. ASHS toilet issue
    && feature.getParent && feature.matchesMetaForArrayOfConditions // just to test methods
    && allDisplayLogicCartItems.some(cartItem => {
      return cartItem.cartFeature
        && cartItem.cartFeature.dbFeature
        && (cartItem.cartFeature.dbFeature.sharedFeatureName === feature.dbFeature.sharedFeatureName)
        && (cartItem.cartFeature.dbFeature.groupName === feature.dbFeature.groupName)
        && cartItem.cartFeature.dbFeature.id && feature.dbFeature.id
        && (cartItem.cartFeature.dbFeature.id !== feature.dbFeature.id)
    }) // there are multiple types of this feature, check this one for the metadata
  ) {
    const featureGroup = feature.getParent();
    visible = feature.matchesMetaForArrayOfConditions(featureGroup.getArrayOfConditions());
  }
  if (visible && !quantity) {
    quantity = 1;
  }
  return {quantity, isMatching: visible};
}

/**
 *
 * @param feature {object} (object which has dbFeature property)
 * @param propertyName {string}
 * @param originalValue {any}
 * @param fromQtCategory {string} (cart feature should be calculated from the category it was added)
 * @return {number}
 */
export const checkIfInCatProperty = (feature, propertyName, originalValue, fromQtCategory) => {
  const finalValue = (typeof originalValue !== "undefined") ? originalValue : feature.dbFeature[propertyName];
  if (feature.inCatProperties && fromQtCategory && feature.inCatProperties.hasOwnProperty(fromQtCategory)
    && feature.inCatProperties[fromQtCategory].hasOwnProperty(propertyName)) {
    if (propertyName === "inCatPrice") {
      const {settings} = store.getState().fabricatorState;
      if (settings.showSalePrices && (typeof feature.inCatProperties[fromQtCategory].inCatFabCost == "number")) {
        return feature.inCatProperties[fromQtCategory].inCatFabCost
      }
      return (typeof feature.inCatProperties[fromQtCategory].inCatCost === "number")
        ? feature.inCatProperties[fromQtCategory].inCatCost
        : (typeof feature.inCatProperties[fromQtCategory].inCatPrice === "number")
          ? feature.inCatProperties[fromQtCategory].inCatPrice
          : finalValue
    }
    return feature.inCatProperties[fromQtCategory][propertyName] // inCatValue
  }
  return finalValue;
}

/**
 * returns old dbFeature property name for displaying/hiding the feature
 * @param forPage {string} quotingTool || visualizer
 * @param visualizerType {string}
 * @return {string}
 */
export const getOldHidePropertyName = (forPage = "quotingTool", visualizerType = getCommonVisualizerType()) => {
  let hidePropertyName = "";
  switch (visualizerType) {
    case "kitchen":
      hidePropertyName = (forPage === "quotingTool") ? "hideFromFrontEnd" : "hideFromKitchenVisualizer";
      break;
    case "bathroom":
      hidePropertyName = (forPage === "quotingTool") ? "hideFromBVQT" : "hideFromBathroomVisualizer";
      break;
    default:
      break;
  }
  return hidePropertyName
}

/**
 * common function for displaying/hiding the feature
 * @param feature {featureInterface}
 * @param forPage {string} quotingTool || visualizer
 * @param fromQtCategory {string} for specific category
 * @param visualizerType {string} for specific visualizerType
 * @return {boolean}
 */
export const isFeatureEnabled = (feature, forPage = "quotingTool", fromQtCategory = "", visualizerType = getCommonVisualizerType()) => {

  // if (feature.dbFeature.sharedFeatureName === "53010 1 American Standard Ceramic") { // for testing
  //   debugger;//eslint-disable-line
  // }

  const hidePropertyName = getOldHidePropertyName(forPage, visualizerType);

  if (feature.inCatProperties && fromQtCategory && feature.inCatProperties.hasOwnProperty(fromQtCategory)
    && feature.inCatProperties[fromQtCategory].hasOwnProperty(hidePropertyName)) {
    return !feature.inCatProperties[fromQtCategory][hidePropertyName]
  }

  const toolSettings = feature.dbFeature.toolSettings;
  if (Array.isArray(toolSettings) && toolSettings.length) {
    const checkProperty = forPage === "quotingTool" ? "enableQuotingTool" : "enableVisualizer";
    return toolSettings.some(toolSettingsObject => toolSettingsObject.tool === visualizerType && toolSettingsObject[checkProperty])
  }

  return !feature.dbFeature[hidePropertyName]
}

const setFabricatorFeatureCategoriesProperties = (feature) => {
  if (Array.isArray(feature.dbFeature.fabricatorFeatureCategories) && feature.dbFeature.fabricatorFeatureCategories.length && !feature.fabricatorFeatureCategoriesPropertiesAreSet) {
    const parent = feature.getParent();
    const layout = parent.layout || parent.getParent().layout; // Floor & ceiling doesn't have getParent() function
    if (layout.qtCategoriesList && parent.qtCategoryName) { // do not change to qtCategory since there will be a Maximum call stack
      if (!feature.inCatProperties) {
        feature.inCatProperties = {};
      }
      Object.keys(parent.qtCatProperties).forEach(qtCatName => {
        const inCat = layout.qtCategoriesList.find(qtCat => qtCat.name === qtCatName);
        if (!inCat) {
          return
        }
        for (let i = 0; i < feature.dbFeature.fabricatorFeatureCategories.length; i++) {
          const currentFabricatorFeatureCategory = feature.dbFeature.fabricatorFeatureCategories[i];
          if (currentFabricatorFeatureCategory.fabricatorFeatureCategoryId === inCat.id) {
            if (!feature.inCatProperties[qtCatName]) {
              feature.inCatProperties[qtCatName] = {};
            }
            if (currentFabricatorFeatureCategory.price !== null) {
              feature.inCatProperties[qtCatName].inCatPrice = currentFabricatorFeatureCategory.price;
            }
            if (currentFabricatorFeatureCategory.cost !== null) {
              feature.inCatProperties[qtCatName].inCatCost = currentFabricatorFeatureCategory.cost;
            }
            if (currentFabricatorFeatureCategory.fabricatorCost !== null) {
              feature.inCatProperties[qtCatName].inCatFabCost = currentFabricatorFeatureCategory.fabricatorCost; // not used for now
            }
            if (currentFabricatorFeatureCategory.displayName !== null) {
              feature.inCatProperties[qtCatName].inCatName = currentFabricatorFeatureCategory.displayName;
            }
            if (currentFabricatorFeatureCategory.complexLogic) {
              feature.inCatProperties[qtCatName].complexLogic = currentFabricatorFeatureCategory.complexLogic;
            }
            if (Array.isArray(currentFabricatorFeatureCategory.toolSettings) && currentFabricatorFeatureCategory.toolSettings.length) {
              const bvSetting = currentFabricatorFeatureCategory.toolSettings.find(setting => setting.tool === "bathroom");
              const kvSetting = currentFabricatorFeatureCategory.toolSettings.find(setting => setting.tool === "kitchen");
              if (bvSetting) {
                feature.inCatProperties[qtCatName].hideFromBathroomVisualizer = !bvSetting.enableVisualizer;
                feature.inCatProperties[qtCatName].hideFromBVQT = !bvSetting.enableQuotingTool;
              }
              if (kvSetting) {
                feature.inCatProperties[qtCatName].hideFromKitchenVisualizer = !kvSetting.enableVisualizer;
                feature.inCatProperties[qtCatName].hideFromFrontEnd = !kvSetting.enableQuotingTool;
              }
            } else { // old logic
              // feature.inCatProperties[qtCatName].hideFromBathroomVisualizer = currentFabricatorFeatureCategory.hideFromBV;
              feature.inCatProperties[qtCatName].hideFromBathroomVisualizer
                = feature.dbFeature.fabricatorFeatureCategories.every(fCat => fCat.hideFromBV) && feature.dbFeature.hideFromBV;  // hide feature from visualizer only if it is disabeld everywhere
              feature.inCatProperties[qtCatName].hideFromBVQT = currentFabricatorFeatureCategory.hideFromBVQT;
              // feature.inCatProperties[qtCatName].hideFromKitchenVisualizer = currentFabricatorFeatureCategory.hideFromKV;
              feature.inCatProperties[qtCatName].hideFromKitchenVisualizer =
                feature.dbFeature.fabricatorFeatureCategories.every(fCat => fCat.hideFromKV) && feature.dbFeature.hideFromKV;   // hide feature from visualizer only if it is disabeld everywhere
              feature.inCatProperties[qtCatName].hideFromFrontEnd = currentFabricatorFeatureCategory.hideFromKVQT;
            }
            break;
          }
        }
      });
      feature.fabricatorFeatureCategoriesPropertiesAreSet = true;
    }
  }
  return feature
}

export const isVisibleForNavigation = (feature, withQuotingToolFeatures, forActiveQTCategory = "") => {

  if (!feature || !feature.dbFeature) {  // 1) check for something unexpected (just in case)
    return false
  }

  feature = setFabricatorFeatureCategoriesProperties(feature);  // 2) set properties from fabricatorFeatureCategories

  if (feature.dbFeature.autoAddToCart) {
    return document.kvConfig.userId === 157678 //hardcode https://tshopinc.quotekitchenandbath.com/kitchen?mode=dashboard they should have labor feature displayed
  } else if (withQuotingToolFeatures && (withQuotingToolFeatures !== "all") // for look and product journey - we show all features
    && !isFeatureEnabled(feature, "quotingTool", forActiveQTCategory)) {
    return false
  }  else if (withQuotingToolFeatures && (withQuotingToolFeatures === "all") // for look and product journey - we show all features (enabled)
    && !isFeatureEnabled(feature, "quotingTool", forActiveQTCategory)
    && !isFeatureEnabled(feature, "visualizer", forActiveQTCategory)) {
    return false
  } else if (feature.dbFeature.displayLogic) {
    const storeState = store.getState();
    return featureIsMatchingDisplayLogic(
      feature,
      storeState.cartState.cartItems,
      storeState.quotesState.activeQuoteIndex,
      storeState.wizardState.allWizardsValues,
      storeState.cartState.displayLogicCartItems,
      storeState.fabricatorState,
    )
  }
  return true
};

function wizardHasSelectedWizardGroupId(wizardGroupId, allWizardsValues, currentQuote) {
  return allWizardsValues && allWizardsValues.some(wizObject => {
    return wizObject.quoteIndex === currentQuote && wizObject.wizardSelectedValues
      && Object.keys(wizObject.wizardSelectedValues).some(key => {
        return wizObject.wizardSelectedValues[key].wizardGroup
          && wizObject.wizardSelectedValues[key].wizardGroup.id === wizardGroupId
      })
  })
}

/**
 * @returns {object} // {visible, quantity, shouldChange}
 * */
function getRenuitFeeAndPsaVisible(feature, cartItems, allWizardsValues, currentQuote) {
  let returnObject = {visible: true, quantity: 0, shouldChange: false};
  if (feature.partId === "fee") {
    if (feature.dbFeature.sharedFeatureName !== "Reface framed fee" && feature.dbFeature.sharedFeatureName !== "Reface Fee") {
      return returnObject // do not update others
    }
    const neededWizardGroupId = feature.dbFeature.sharedFeatureName === "Reface framed fee" ? "1" : "2";
    returnObject.visible = wizardHasSelectedWizardGroupId(neededWizardGroupId, allWizardsValues, currentQuote);
    returnObject.quantity = !returnObject.visible ? 0 : cartItems.reduce(((totalQuantity, cItem) => {
      if ((cItem.partId === "top_cabinet" ||  cItem.partId === "bottom_cabinet") && cItem.currentQuote === currentQuote) {
        totalQuantity = totalQuantity + cItem.quantity;
      }
      return totalQuantity
    }), 0);
    return {visible: returnObject.quantity > 0, quantity: returnObject.quantity, shouldChange: true}
  } else if (feature.partId === "psa") {
    returnObject.shouldChange = true;
    returnObject.visible = wizardHasSelectedWizardGroupId("4", allWizardsValues, currentQuote)
    if (returnObject.visible) {
      returnObject.quantity = getPSADefaultQuantity(feature, cartItems, currentQuote);
    }
    returnObject.visible = returnObject.quantity > 0;
  }
  return returnObject
}
